<div class="doc-page">
  <div class="doc-content">

    <!-- Version Info Banner -->
    <div class="version-banner">
      <p [innerHTML]="'documentation.versionBanner' | translate"></p>
    </div>

    <div class="doc-body" [innerHTML]="docHtml"></div>

  </div>
</div>
